export default function APIResults() {
  return (
    <div>
      <p>API Results</p>
    </div>
  );
}
